
import axios from 'axios';
import authHeader from './auth-header';
import ConfigService from './ConfigService';
import ApiClient from './ApiClient';

//import { API_URL,API_URL_PAYMENT,PUBLIC_URL } from '../base';
//http://138.201.249.173:8080/swagger-ui.html#/
//http://138.201.249.173:8092/swagger-ui.html#/
/*   const API_URL = 'http://138.201.249.173:8091';
const API_URL_PAYMENT = 'http://138.201.249.173:8085';
const PUBLIC_URL = 'http://138.201.249.173:8092';   */


class ApiService {



  getRequest(url, header = true) {

    let Axios = axios;

    let headers = {}
    if (header) {
      headers = { headers: authHeader() }
      Axios = ApiClient;

    }

    return Axios.get(ConfigService.API_URL + url, headers);

  }


  postRequest(url, queryparam = {}, header = true) {
    let Axios = axios;

    let headers = {}
    if (header) {
      headers = { headers: authHeader() }
      Axios = ApiClient;

    }
    return Axios.post(ConfigService.API_URL + url, queryparam, headers);
  }


  publicGetRequest(url, header = false) {
    let Axios = axios;


    let headers = {}
    if (header) {
      headers = { headers: authHeader() }
      Axios = ApiClient;

    }

    return Axios.get(ConfigService.PUBLIC_URL + url, headers);
    //.then((response) => response.data)

  }

  publicPostRequest(url, queryparam = {}, header = false) {
    let Axios = axios;

    let headers = {}
    if (header) {
      headers = { headers: authHeader() }
      Axios = ApiClient;

    }
    return Axios.post(ConfigService.PUBLIC_URL + url, queryparam, headers);

  }
  publicPostRequestFile(url, queryparam = {}, header = false) {
    let Axios = axios;

    let headers = {}
    if (header) {
      headers = { headers: authHeader() }
      Axios = ApiClient;

    }
    return Axios.post(ConfigService.FILE_URL + url, queryparam, headers);

  }

  paymentGetRequest(url, header = true) {

    let Axios = axios;

    let headers = {}
    if (header) {
      headers = { headers: authHeader() }
      Axios = ApiClient;

    }
    return Axios.get(ConfigService.API_URL_PAYMENT + url, headers);

  }




  paymentPostRequest(url, queryparam = {}, header = true) {
    let Axios = axios;

    let headers = {}
    if (header) {
      headers = { headers: authHeader() }
      Axios = ApiClient;

    }
    return Axios.post(ConfigService.API_URL_PAYMENT + url, queryparam, headers);
  }

  publicDeleteRequest(url, header = false) {
    let Axios = axios;

    let headers = {}
    if (header) {
      headers = { headers: authHeader() }
      Axios = ApiClient;

    }

    return Axios.delete(ConfigService.PUBLIC_URL + url, headers);

  }



  promiseWrapper = (promise, delay = 3000) => {
    let status = "pending";
    let result;

    const s = promise
      .then((value) => {
        return new Promise((resolve) => {
          setTimeout(() => {
            status = "success";
            result = value;
            resolve(value);
          }, delay);
        });
      })
      .catch((error) => {
        status = "error";
        result = error;
      });

    return () => {
      switch (status) {
        case "pending":
          throw s;
        case "success":
          return result;
        case "error":
          throw result;
        default:
          throw new Error("Unknown status");
      }
    };
  };
}


export default new ApiService();
